<div class="contact-info-container">
    <div class="contact-section" id="primary-customer-section">
        <h3>Primary Customer Information</h3>
        <ng-container *ngIf="!customer?.id; else customerInfo">
            <p>
                Primary customer still has not been added to the system. Add the customer to proceed with setting up monitoring services for
                this account.
            </p>
            <div class="section-action">
                <button mat-raised-button class="mat-clare-primary contact-btn" (click)="editUser()">Add Customer Information</button>
            </div>
        </ng-container>
    </div>
    <div class="divider"></div>
    <div class="contact-section" id="emergency-municipality">
        <h3>Emergency and Municipality Contacts (Optional)</h3>
        <p>Additional contact for the central station to reach out in case of an emergency they cannot reach the primary customer.</p>
        <div class="section-action">
            <button mat-stroked-button class="mat-clare-primary contact-btn" (click)="openAddContactForm()">+ Emergency Contact</button>
            <button mat-stroked-button class="mat-clare-primary contact-btn" (click)="openManucipalityForm()">
                + Municipality Contact
            </button>
        </div>
    </div>
</div>

<ng-template #customerInfo>
    <div class="customer-info">
        <p class="intro">Primary customer information complete.</p>
        <div class="info">
            <div class="customer-data">
                <div class="customer-name">{{ customer.firstName }} {{ customer.lastName }}</div>
                <div class="customer-email">
                    {{ customer.email }}
                </div>
            </div>
            <div class="action">
                <button mat-stroked-button class="mat-clare-primary contact-btn" (click)="editUser()">Edit</button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #addManucipalityTmpl>
    <clare-edit-municipality
        [updateItem]="municipality"
        (cancel)="closeDialog()"
        (save)="upsertMunicipality($event)"
    ></clare-edit-municipality>
</ng-template>

<ng-template #addContactTmpl>
    <app-add-contact (cancel)="closeDialog()" (save)="saveContact($event)"></app-add-contact>
</ng-template>
